<template>
	<div v-if="display" class="modal is-active">
		<div class="modal-content">
			<section class="hero is-fullheight is-black" :class="{'slide-out-top': !loading}" style="z-index: 999">
				<div class="hero-body">
					<div class="container has-text-centered">
						<figure
							class="image is-128x128"
							style="margin: auto; margin-bottom: 30px"
						>
							<img src="~@/assets/logo.png" />
						</figure>
						<br />
						<progress
							class="progress is-small is-primary"
							:value="progress"
							min="0"
							max="100"
							style="max-width: 300px; margin: auto"
						></progress>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	mounted: function () {
		var vm = this;

		vm.preload(vm.images, function () {
            vm.loading = false;
            setTimeout(() => {
                vm.display = false
            }, 1500);
		});
	},
	methods: {
		preload: function (images, callback) {
			var counter = 0;
			var total = images.length;
			var vm = this;

			images.forEach((element) => {
				preloadImage(element, function () {
					counter++;
					vm.progress = (counter / total) * 100;
					if (counter == total) {
						setTimeout(() => {
                            callback();
                        }, 500);
					}
				});
			});

			function preloadImage(url, callback) {
				var img = new Image();
				img.onload = callback;
				img.src = url;
			}
		},
		loadComplete: function (event) {
			console.log(event);
		},
	},
	data: function () {
		return {
            display: true,
			loading: true,
			progress: 0,
			images: [
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/landing-mobile.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/lecture-mobile.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/stand-mobile.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/group-mobile.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/meet-mobile.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/contact-mobile.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/landing-desktop.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/lecture-desktop.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/stand-desktop.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/group-desktop.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/meet-desktop.jpg",
				"https://fitcocontent.nyc3.cdn.digitaloceanspaces.com/images/contact-desktop.jpg",
			],
		};
	},
};
</script>

<style>
.progress.is-small {
	height: 0.45rem !important;
}
.modal-content {
	max-height: none !important;
}
.progress::-webkit-progress-value {
	transition: width 0.5s ease;
}

.slide-out-top {
	-webkit-animation: slide-out-top 1.5s cubic-bezier(0.55, 0.085, 0.68, 0.53)
		both;
	animation: slide-out-top 1.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2020-11-2 19:50:30
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-out-top
 * ----------------------------------------
 */
@-webkit-keyframes slide-out-top {
	0% {
		-webkit-transform: translateY(0);
		transform: translateY(0);
		opacity: 1;
	}
	100% {
		-webkit-transform: translateY(-1000px);
		transform: translateY(-1000px);
		opacity: 0;
	}
}
@keyframes slide-out-top {
	0% {
		-webkit-transform: translateY(0);
		transform: translateY(0);
		opacity: 1;
	}
	100% {
		-webkit-transform: translateY(-1000px);
		transform: translateY(-1000px);
		opacity: 0;
	}
}
</style>